<app-header></app-header>

<div class="flex min-h-screen bg-gray-50">
  <!-- Left Sidebar - Stepper -->
  <aside class="w-[20%] flex-shrink-0 bg-white border-r border-gray-200">
    <app-stepper [currentStep]="activeStep"></app-stepper>
  </aside>

  <!-- Main Content Area -->
  <main class="flex-1 p-8">
    <div class="mx-5">
      <!-- Page Title -->
      <h1 class="text-3xl font-bold text-gray-900 mb-2">
        {{ "ONBOARDING.COMPANY_DETAILS_TITLE" | translate }}
      </h1>
      <p class="text-gray-600 mb-8">
        {{ "ONBOARDING.COMPANY_DETAILS_DESC" | translate }}
      </p>

      <!-- Form Card -->
      <div class="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
        <!-- Form Grid -->
        <div
          class="grid gap-6 mb-8"
          [ngClass]="fromGetQuote === 'true' ? 'grid-cols-2' : 'grid-cols-2'"
        >
          <!-- Commercial Registration Number -->
          <div class="form-field">
            <label
              for="companyId"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.CR_NUMBER_LABEL" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <select
              id="companyId"
              [(ngModel)]="companyId"
              name="companyId"
              (ngModelChange)="onCompanySelect($event)"
              #companyIdInput="ngModel"
              required
              class="w-full px-4 py-4 bg-[#F3F3F5] border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            >
              <option value="" disabled selected>
                {{ "ONBOARDING.SELECT_CR_NUMBER" | translate }}
              </option>
              <option *ngFor="let cr of crNumberOptions" [value]="cr.id">
                {{ cr.crNumber }} - {{ cr.name }}
              </option>
            </select>
            <div
              *ngIf="
                companyIdInput.invalid &&
                (companyIdInput.dirty || companyIdInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="companyIdInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.CR_REQUIRED" | translate }}
              </div>
            </div>
          </div>

          <!-- Policy Start Date -->
          <div class="form-field">
            <label
              for="policyStartDate"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.POLICY_START_DATE" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="date"
              id="policyStartDate"
              [(ngModel)]="policyStartDate"
              name="policyStartDate"
              [min]="minDate"
              #dateInput="ngModel"
              required
              placeholder="dd-mm-yyyy"
              class="w-full px-4 py-3.5 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                dateInput.invalid && (dateInput.dirty || dateInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="dateInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.POLICY_DATE_REQUIRED" | translate }}
              </div>
            </div>
          </div>

          <!-- Phone Number (conditional) -->
          <div class="form-field">
            <label
              for="phoneNumber"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.PHONE_NUMBER" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="phoneNumber"
              [(ngModel)]="phoneNumber"
              name="phoneNumber"
              #phoneInput="ngModel"
              required
              pattern="^[0-9]{10}$"
              [placeholder]="'ONBOARDING.PHONE_PLACEHOLDER' | translate"
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="phoneInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.PHONE_REQUIRED" | translate }}
              </div>
              <div *ngIf="phoneInput.errors?.['pattern']">
                {{ "ONBOARDING.ERRORS.PHONE_INVALID" | translate }}
              </div>
            </div>
          </div>

          <!-- Company Name (English) -->
          <div class="form-field">
            <label
              for="companyNameEn"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.COMPANY_NAME_EN_LABEL" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="companyNameEn"
              [(ngModel)]="companyNameEn"
              name="companyNameEn"
              #companyNameEnInput="ngModel"
              required
              [placeholder]="
                'ONBOARDING.COMPANY_NAME_EN_PLACEHOLDER' | translate
              "
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                companyNameEnInput.invalid &&
                (companyNameEnInput.dirty || companyNameEnInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="companyNameEnInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.COMPANY_NAME_EN_REQUIRED" | translate }}
              </div>
            </div>
          </div>

          <!-- Company Name (Arabic) -->
          <div class="form-field">
            <label
              for="companyNameAr"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.COMPANY_NAME_AR_LABEL" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="companyNameAr"
              [(ngModel)]="companyNameAr"
              name="companyNameAr"
              #companyNameArInput="ngModel"
              required
              [placeholder]="
                'ONBOARDING.COMPANY_NAME_AR_PLACEHOLDER' | translate
              "
              dir="rtl"
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                companyNameArInput.invalid &&
                (companyNameArInput.dirty || companyNameArInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="companyNameArInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.COMPANY_NAME_AR_REQUIRED" | translate }}
              </div>
            </div>
          </div>

          <!-- Number of Employees -->
          <div class="form-field">
            <label
              for="numberOfEmployees"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.NUMBER_OF_EMPLOYEES_LABEL" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="numberOfEmployees"
              [(ngModel)]="numberOfEmployees"
              name="numberOfEmployees"
              #employeesInput="ngModel"
              required
              min="1"
              [placeholder]="
                'ONBOARDING.NUMBER_OF_EMPLOYEES_PLACEHOLDER' | translate
              "
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                employeesInput.invalid &&
                (employeesInput.dirty || employeesInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="employeesInput.errors?.['required']">
                {{
                  "ONBOARDING.ERRORS.NUMBER_OF_EMPLOYEES_REQUIRED" | translate
                }}
              </div>
              <div *ngIf="employeesInput.errors?.['min']">
                {{ "ONBOARDING.ERRORS.NUMBER_OF_EMPLOYEES_MIN" | translate }}
              </div>
            </div>
          </div>

          <!-- Email (conditional) -->
          <div *ngIf="fromGetQuote === 'true'" class="form-field">
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "LANDING.FORM.EMAIL" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              #emailInput="ngModel"
              required
              email
              [placeholder]="'LANDING.FORM.EMAIL_PLACEHOLDER' | translate"
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                emailInput.invalid && (emailInput.dirty || emailInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="emailInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.EMAIL_REQUIRED" | translate }}
              </div>
              <div *ngIf="emailInput.errors?.['email']">
                {{ "ONBOARDING.ERRORS.EMAIL_INVALID" | translate }}
              </div>
            </div>
          </div>
          <div class="form-field">
            <label
              for="sponsorID"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.SPONSOR_ID" | translate }}
            </label>
            <input
              type="text"
              id="sponsorID"
              [(ngModel)]="sponsorID"
              name="sponsorID"
              #sponsorIDInput="ngModel"
              required
              [placeholder]="
                'ONBOARDING.SPONSOR_ID_PLACEHOLDER_OPTIONAL' | translate
              "
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                sponsorIDInput.invalid &&
                (sponsorIDInput.dirty || sponsorIDInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="sponsorIDInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.SPONSOR_ID_REQUIRED" | translate }}
              </div>
            </div>
          </div>
          <div class="form-field">
            <label
              for="entity700Number"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              {{ "ONBOARDING.ENTITY_700_NUMBER" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="entity700Number"
              [(ngModel)]="entity700Number"
              name="entity700Number"
              #entity700NumberInput="ngModel"
              required
              [placeholder]="
                'ONBOARDING.ENTITY_700_PLACEHOLDER_REQUIRED' | translate
              "
              class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
            <div
              *ngIf="
                entity700NumberInput.invalid &&
                (entity700NumberInput.dirty || entity700NumberInput.touched)
              "
              class="text-red-600 text-sm mt-1"
            >
              <div *ngIf="entity700NumberInput.errors?.['required']">
                {{ "ONBOARDING.ERRORS.ENTITY_700_REQUIRED" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Continue Button -->
      </div>
    </div>
    <div class="flex justify-end pt-6 border-gray-200">
      <button
        type="button"
        (click)="onContinue()"
        class="px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-colors duration-200 flex items-center gap-2"
      >
        {{ "ONBOARDING.CONTINUE_TO_ADD_MEMBERS" | translate }}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 15L12.5 10L7.5 5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </main>
</div>

<app-footer layout="slim"></app-footer>
